import produce from "immer";
import {
  FETCH_ROLES,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_ROLES,
  ADD_ROLES_SUCCESS,
  ADD_ROLES_FAILURE,
  //
  EDIT_ROLES,
  EDIT_ROLES_SUCCESS,
  EDIT_ROLES_FAILURE,
  //
  DELETE_ROLES,
  DELETE_ROLES_SUCCESS,
  DELETE_ROLES_FAILURE,
  //
  SEARCH_ROLES,
  SEARCH_ROLES_SUCCESS,
  SEARCH_ROLES_FAILURE,
  //
  SET_ROLE,
  SET_ROLE_SUCCESS,
  SET_ROLE_FAILURE,
  //
  UPDATE_SEQ,
  UPDATE_SEQ_SUCCESS,
  UPDATE_SEQ_FAILURE,
  //
  SEARCH_EMP_ROLES,
  SEARCH_EMP_ROLES_SUCCESS,
  SEARCH_EMP_ROLES_FAILURE,
  //
  FETCH_HISTORY,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAILURE,
  TOGGLE_HISTORY_MODAL,
} from "./constants";

export const initialState = {
  isFetchingRole: false,
  roleList: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentRole: {},
  // Delete
  isDeleting: false,
  isSearching: false,
  searchList: [],
  //
  isSettingRole: false,
  //
  isSearchingEmpRoles: false,
  empRoles: [],
  //
  isFetchingHistory: false,
  roleHistory: [],
  roleHistoryModal: {
    open: false,
  },
};

const RosterRoleReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_ROLES:
        draft.isFetchingRole = true;
        draft.roleList = [];
        break;
      case FETCH_ROLES_SUCCESS:
        draft.isFetchingRole = false;
        draft.roleList = action.payload;
        break;
      case FETCH_ROLES_FAILURE:
        draft.isFetchingRole = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentRole = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentRole = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentRole = {};
        break;
      // Add
      case ADD_ROLES:
        draft.isSubmitting = true;
        break;
      case ADD_ROLES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ROLES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_ROLES:
        draft.isSubmitting = true;
        break;
      case EDIT_ROLES_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_ROLES_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_ROLES:
        draft.isDeleting = true;
        break;
      case DELETE_ROLES_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ROLES_FAILURE:
        draft.isDeleting = false;
        break;

      // Delete
      case SEARCH_ROLES:
        draft.isSearching = true;
        draft.searchList = [];
        break;
      case SEARCH_ROLES_SUCCESS:
        draft.isSearching = false;
        draft.searchList = action.payload;
        break;
      case SEARCH_ROLES_FAILURE:
        draft.isSearching = false;
        draft.searchList = [];
        break;

      // Delete
      case SET_ROLE:
        draft.isSettingRole = true;
        break;
      case SET_ROLE_SUCCESS:
        draft.isSettingRole = false;
        break;
      case SET_ROLE_FAILURE:
        draft.isSettingRole = false;
        break;

      // Delete
      case UPDATE_SEQ:
        draft.isUpdatingSeq = true;
        break;
      case UPDATE_SEQ_SUCCESS:
        draft.isUpdatingSeq = false;
        break;
      case UPDATE_SEQ_FAILURE:
        draft.isUpdatingSeq = false;
        break;

      // Delete
      case SEARCH_EMP_ROLES:
        draft.isSearchingEmpRoles = true;
        draft.searchList = [];
        break;
      case SEARCH_EMP_ROLES_SUCCESS:
        draft.isSearchingEmpRoles = false;
        draft.searchList = action.payload;
        break;
      case SEARCH_EMP_ROLES_FAILURE:
        draft.isSearchingEmpRoles = false;
        draft.searchList = [];
        break;

      case FETCH_HISTORY:
        draft.isFetchingHistory = true;
        draft.roleHistory = [];
        break;
      case FETCH_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.roleHistory = action.payload;
        break;
      case FETCH_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.roleHistory = [];
        break;

      case TOGGLE_HISTORY_MODAL:
        draft.roleHistoryModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default RosterRoleReducer;
